export { getInitialThreadViewState } from '../_internal/selectors/getInitialThreadViewState';